import { Field, Form, Formik } from 'formik';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import BackButton from '../../components/BackButton';
import { FloatingPlaceholder } from '../../components/FloatingPlaceholder';
import { Loader } from '../../components/Loader';
import { SubmitButton } from '../../components/SubmitButton';
import * as actions from "../../redux/cronexpressions";

class CronExpressionDetails extends Component {
    componentDidMount() {
        this.props.fetchcronexpressions(this.props);
    }

    save = (values, { setSubmitting }) => {
        this.props.addOrUpdateItem(values).finally(() => setSubmitting(false));
    }

    render() {
        return (
            <div>
                <h1>Cron Expression</h1>
                <BackButton />
                <Loader loading={this.props.loading && this.props.cronexpression}>
                    <Formik
                        initialValues={this.props.cronexpression}
                        onSubmit={this.save}
                        enableReinitialize={true}>
                        {({ isSubmitting }) => (
                            <Form>
                                <Field type="text" name="description" component={FloatingPlaceholder} placeholder="Description" />
                                <Field type="text" name="expression" component={FloatingPlaceholder} placeholder="Expression" />
                                <SubmitButton type="submit" disabled={isSubmitting} classNames={{ 'loading': isSubmitting }} text='Submit' />
                            </Form>
                        )}
                    </Formik>
                </Loader>
            </div>
        );
    }
}

const mapStateToProps = ({ cronexpressions }) => ({
    cronexpression: cronexpressions.cronexpression,
    loading: cronexpressions.loading,
    error: cronexpressions.error
});

export default connect(mapStateToProps, actions)(withRouter(CronExpressionDetails));


// WEBPACK FOOTER //
// ./src/pages/CronExpressions/CronExpressionDetails.js